// @flow
import { CertificacionesActionTypes } from './constants';

type CertificacionesAction = { type: string, payload: {} | string };

// common success
export const certificacionesApiResponseSuccess = (actionType: string, data: any): CertificacionesAction => ({
    type: CertificacionesActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const certificacionesApiResponseError = (actionType: string, error: string): CertificacionesAction => ({
    type: CertificacionesActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getCertificacion = (id: string): CertificacionesAction => ({
    type: CertificacionesActionTypes.GET_CERTIFICACION,
    payload: { id },
});

export const addCertificacion = (certificacion:any):CertificacionesAction=>({
    type:CertificacionesActionTypes.ADD_CERTIFICACION,
    payload:certificacion
})
export const updateCertificacion = (certificacion:any):CertificacionesAction=>({
    type:CertificacionesActionTypes.UPDATE_CERTIFICACION,
    payload:certificacion
})
export const deleteCertificacion = (id:string):CertificacionesAction=>({
    type:CertificacionesActionTypes.DELETE_CERTIFICACION,
    payload:{id}
})

export const listCertificaciones = (params:any): CertificacionesAction => ({
    type: CertificacionesActionTypes.LIST_CERTIFICACIONES,
    payload: params,
});


export const resetCertificaciones = (): CertificacionesAction => ({
    type: CertificacionesActionTypes.RESET,
    payload: {},
});

